import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Omaha, NE?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Omaha can take 2–6 months, especially during busy travel seasons. For STRATCOM families at Offutt AFB, Fortune 500 business travelers, and Creighton students, that timeline is simply not viable.",
  },
  {
    q: "Can Offutt AFB and STRATCOM families expedite a passport quickly?",
    a: "Absolutely. Military families are one of our most common client types in Omaha. PCS orders often arrive with 30 days or less to report, and dependent passports must be current for overseas assignments. We regularly process expedited renewals, new applications, and child passports for Air Force, STRATCOM, and contractor families on compressed timelines. Contact us as soon as orders arrive — do not wait until the week before your flight out of Eppley.",
  },
  {
    q: "What if my passport expires before a business trip to London or Zurich?",
    a: "This is a common situation for Omaha's corporate community. Insurance and reinsurance meetings in London and Zurich are scheduled on fixed dates — you cannot reschedule a board presentation or client negotiation because your passport expired. We process expedited renewals for business travelers, with options as fast as 2–9 business days. Standard mail-in renewal through an Omaha post office typically takes 2–6 months.",
  },
  {
    q: "Can Creighton or UNO students get a passport fast for study abroad?",
    a: "Yes. Study-abroad program deadlines often leave students with as little as 4–6 weeks before orientation. First-time applicants (many college students) require an in-person acceptance clerk visit. We guide Creighton, UNO, and UNMC students through the exact location, forms, and timeline so they do not miss their program orientation in Europe, Latin America, or Asia.",
  },
  {
    q: "How quickly can travelers in Bellevue or Council Bluffs receive an expedited passport?",
    a: "Bellevue and Council Bluffs travelers have the same access to our expedited services as Omaha residents. Since we operate remotely, your physical location in Eastern Nebraska or Western Iowa does not affect processing speed. Ship your documents overnight from Sarpy or Pottawattamie County, and we handle the rest. Most clients in the Omaha metro area receive their passports within 2–9 business days.",
  },
  {
    q: "Can executives at Berkshire Hathaway or Mutual of Omaha get an expedited passport?",
    a: "Yes — Omaha's Fortune 500 professionals are well within our service area. Whether you are attending an annual meeting in London, visiting a reinsurance market in Zurich, or inspecting international facilities in Asia, we make the renewal or new application process straightforward. You do not need to drive to Minneapolis for a passport agency appointment. Start online, ship your documents, and we handle the expedited submission.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Omaha travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Omaha, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Omaha metro area or Eastern Nebraska.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function OmahaFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Omaha and Eastern Nebraska travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}